export default "__VITE_ASSET__1db7d0c1__"